import styled, { css } from 'styled-components';
import { FlexCenterAligned } from '../../../../styled/common';
import { ArrowIcon, TextsContainer } from '../../../ui/Select/styled';

export const borderedSortingStyles = css`
  padding: 15px;
  height: 50px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};

  ${TextsContainer} {
    width: 100%;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${ArrowIcon} {
      display: none;
    }
  }
`;

export const popoverFilterStyles = css`
  padding: 0;
  height: 40px;

  ${TextsContainer} {
    width: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${borderedSortingStyles}
  }
`;

export const SelectedValueContainer = styled(FlexCenterAligned)`
  > svg {
    stroke-width: 0.6;
  }

  font-size: 12px;
  gap: 2px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 5px;
  }
`;

export const SortingLabelText = styled.span`
  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    display: none;
  }
`;

export const SortingContainer = styled.div`
  margin: 0 -10px;

  label {
    height: 54px;
    padding: 0 10px;

    &::after {
      display: none;
    }

    @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      height: 45px;
    }
  }
`;
